import { CALL_SORTED_API } from 'gwx-voyager-components';
import Schemas from './clientInvitations.schema';

const CLIENT_INVITATIONS_REQUEST = 'CLIENT_INVITATIONS_REQUEST';
const CLIENT_INVITATIONS_SUCCESS = 'CLIENT_INVITATIONS_SUCCESS';
const CLIENT_INVITATIONS_FAILURE = 'CLIENT_INVITATIONS_FAILURE';
const GET_CLIENT_INVITATIONS = [
	CLIENT_INVITATIONS_REQUEST,
	CLIENT_INVITATIONS_SUCCESS,
	CLIENT_INVITATIONS_FAILURE
];
const CLIENT_INVITATIONS_RESET = 'RESET';

const fetchClientInvitations = (query) => ({
	[CALL_SORTED_API]: {
		types: GET_CLIENT_INVITATIONS,
		endpoint: 'clientInvitations',
		schema: Schemas.CLIENT_INVITATIONS,
		query,
		mapActionToStateKey: 'clientInvitations'
	}
});

const CLIENT_INVITATION_REQUEST = 'CLIENT_INVITATION_REQUEST';
const CLIENT_INVITATION_SUCCESS = 'CLIENT_INVITATION_SUCCESS';
const CLIENT_INVITATION_FAILURE = 'CLIENT_INVITATION_FAILURE';
const GET_CLIENT_INVITATION = [
	CLIENT_INVITATION_REQUEST,
	CLIENT_INVITATION_SUCCESS,
	CLIENT_INVITATION_FAILURE
];
const CLIENT_INVITATION_RESET = 'RESET';

const fetchClientInvitation = (id, query, mapActionToParentKey) => ({
	[CALL_SORTED_API]: {
		types: GET_CLIENT_INVITATION,
		endpoint: `clientInvitations/${id}`,
		schema: Schemas.CLIENT_INVITATIONS,
		query,
		mapActionToStateKey: 'clientInvitation',
		mapActionToParentKey
	}
});

export const resetClientInvitations = () => (dispatch) => dispatch({ type: CLIENT_INVITATIONS_RESET, mapActionToStateKey: 'clientInvitations' });
export const loadClientInvitations = (query) => (dispatch) => dispatch(fetchClientInvitations(query));
export const showActivationKey = (id) => (dispatch) => dispatch(fetchClientInvitation(id, { showActivationKey: true }, 'clientInvitations'));

const REVOKE_CLIENT_INVITATION_REQUEST = 'REVOKE_CLIENT_INVITATION_REQUEST';
const REVOKE_CLIENT_INVITATION_SUCCESS = 'REVOKE_CLIENT_INVITATION_SUCCESS';
const REVOKE_CLIENT_INVITATION_FAILURE = 'REVOKE_CLIENT_INVITATION_FAILURE';
const REVOKE_CLIENT_INVITATION = [
	REVOKE_CLIENT_INVITATION_REQUEST,
	REVOKE_CLIENT_INVITATION_SUCCESS,
	REVOKE_CLIENT_INVITATION_FAILURE
];

const SEND_CLIENT_INVITATION_REQUEST = 'SEND_CLIENT_INVITATION_REQUEST';
const SEND_CLIENT_INVITATION_SUCCESS = 'SEND_CLIENT_INVITATION_SUCCESS';
const SEND_CLIENT_INVITATION_FAILURE = 'SEND_CLIENT_INVITATION_FAILURE';
const SEND_CLIENT_INVITATION = [
	SEND_CLIENT_INVITATION_REQUEST,
	SEND_CLIENT_INVITATION_SUCCESS,
	SEND_CLIENT_INVITATION_FAILURE
];

const postClientInvitation = (id, body, method = 'POST', query, types) => ({
	[CALL_SORTED_API]: {
		types,
		endpoint: id ? `clientInvitations/${id}` : 'clientInvitations',
		body,
		query,
		method,
		schema: Schemas.CLIENT_INVITATIONS,
		mapActionToStateKey: 'clientInvitation'
	}
});

export const revokeClientInvitation = (id, body, query) => (dispatch) => dispatch(postClientInvitation(id, body, 'PUT', query, REVOKE_CLIENT_INVITATION));
export const sendClientInvitation = (id, body, query) => (dispatch) => dispatch(postClientInvitation(id, body, id ? 'PUT' : 'POST', query, SEND_CLIENT_INVITATION));
export const resetClientInvitation = () => (dispatch) => dispatch({ type: CLIENT_INVITATION_RESET, mapActionToStateKey: 'clientInvitation' });

export const ClientInvitationActionTypes = {
	GET_CLIENT_INVITATION,
	GET_CLIENT_INVITATIONS,
	SEND_CLIENT_INVITATION,
	REVOKE_CLIENT_INVITATION
};
